import { mapGetters } from 'vuex';
import Vue from 'vue';

const refreshData = Vue.extend({
  computed: {
    ...mapGetters('user', ['accessToken']),
  },
  watch: {
    accessToken() {
      this['loadData']();
    },
  }
});

export default refreshData;